import { isEmpty } from "lodash";

export const getNameDisplayValue = (value, resultMetaData) => {
  if (!isEmpty(value)) {
    return value;
  }

  const companyName = resultMetaData?.company_name;

  if (!isEmpty(companyName)) {
    return companyName;
  }

  return null;
};

export const shouldRenderNameDash = props =>
  getNameDisplayValue(props.value, props.resultMetaData) === null;
